module.exports = __webpack_public_path__ + "static/media/facebook.c1e76960.svg";